import React from 'react';
import {
  Scissors,
  FolderInput,
  Download,
  Trash2,
  Forward,
  Mail,
  AtSign,
  FileEdit,
} from 'lucide-mui';

import { requestStatusType } from '../../../types';
import { FeatureKey } from '../../plan/upgrade/upgradeView/featureLimits';

export type ActionType =
  | 'share'
  | 'download'
  | 'trim'
  | 'move'
  | 'delete'
  | 'clip'
  | 'embed'
  | 'tagUser'
  | 'shareEmail'
  | 'rename';

export const VIDEO_ACTIONS: {
  actionType: ActionType;
  featureKey?: FeatureKey;
  tooltipMessages: Record<requestStatusType, string>;
  buttonTexts: Record<requestStatusType, string>;
  IconComponent: React.ElementType;
}[] = [
  {
    actionType: 'rename',
    tooltipMessages: {
      idle: 'actions.rename.tooltip.idle',
      pending: 'actions.rename.tooltip.pending',
      succeeded: 'actions.rename.tooltip.succeeded',
      failed: 'actions.rename.tooltip.failed',
    },
    buttonTexts: {
      idle: 'actions.rename.button.idle',
      pending: 'actions.rename.button.pending',
      succeeded: 'actions.rename.button.succeeded',
      failed: 'actions.rename.button.failed',
    },
    IconComponent: FileEdit,
  },
  {
    actionType: 'share',
    tooltipMessages: {
      idle: 'actions.share.tooltip.idle',
      pending: 'actions.share.tooltip.pending',
      succeeded: 'actions.share.tooltip.succeeded',
      failed: 'actions.share.tooltip.failed',
    },
    buttonTexts: {
      idle: 'actions.share.button.idle',
      pending: 'actions.share.button.pending',
      succeeded: 'actions.share.button.succeeded',
      failed: 'actions.share.button.failed',
    },
    IconComponent: Forward,
  },
  {
    actionType: 'clip',
    tooltipMessages: {
      idle: 'actions.clip.tooltip.idle',
      pending: 'actions.clip.tooltip.pending',
      succeeded: 'actions.clip.tooltip.succeeded',
      failed: 'actions.clip.tooltip.failed',
    },
    buttonTexts: {
      idle: 'actions.clip.button.idle',
      pending: 'actions.clip.button.pending',
      succeeded: 'actions.clip.button.succeeded',
      failed: 'actions.clip.button.failed',
    },
    IconComponent: Scissors,
  },
  {
    actionType: 'download',
    featureKey: 'download',
    tooltipMessages: {
      idle: 'actions.download.tooltip.idle',
      pending: 'actions.download.tooltip.pending',
      succeeded: 'actions.download.tooltip.succeeded',
      failed: 'actions.download.tooltip.failed',
    },
    buttonTexts: {
      idle: 'actions.download.button.idle',
      pending: 'actions.download.button.pending',
      succeeded: 'actions.download.button.succeeded',
      failed: 'actions.download.button.failed',
    },
    IconComponent: Download,
  },
  {
    actionType: 'trim',
    tooltipMessages: {
      idle: 'actions.trim.tooltip.idle',
      pending: 'actions.trim.tooltip.pending',
      succeeded: 'actions.trim.tooltip.succeeded',
      failed: 'actions.trim.tooltip.failed',
    },
    buttonTexts: {
      idle: 'actions.trim.button.idle',
      pending: 'actions.trim.button.pending',
      succeeded: 'actions.trim.button.succeeded',
      failed: 'actions.trim.button.failed',
    },
    IconComponent: Scissors,
  },
  {
    actionType: 'move',
    tooltipMessages: {
      idle: 'actions.move.tooltip.idle',
      pending: 'actions.move.tooltip.pending',
      succeeded: 'actions.move.tooltip.succeeded',
      failed: 'actions.move.tooltip.failed',
    },
    buttonTexts: {
      idle: 'actions.move.button.idle',
      pending: 'actions.move.button.pending',
      succeeded: 'actions.move.button.succeeded',
      failed: 'actions.move.button.failed',
    },
    IconComponent: FolderInput,
  },
  {
    actionType: 'delete',
    tooltipMessages: {
      idle: 'actions.delete.tooltip.idle',
      pending: 'actions.delete.tooltip.pending',
      succeeded: 'actions.delete.tooltip.succeeded',
      failed: 'actions.delete.tooltip.failed',
    },
    buttonTexts: {
      idle: 'actions.delete.button.idle',
      pending: 'actions.delete.button.pending',
      succeeded: 'actions.delete.button.succeeded',
      failed: 'actions.delete.button.failed',
    },
    IconComponent: Trash2,
  },
  {
    actionType: 'tagUser',
    tooltipMessages: {
      idle: 'actions.tagUser.tooltip.idle',
      pending: 'actions.tagUser.tooltip.pending',
      succeeded: 'actions.tagUser.tooltip.succeeded',
      failed: 'actions.tagUser.tooltip.failed',
    },
    buttonTexts: {
      idle: 'actions.tagUser.button.idle',
      pending: 'actions.tagUser.button.pending',
      succeeded: 'actions.tagUser.button.succeeded',
      failed: 'actions.tagUser.button.failed',
    },
    IconComponent: AtSign,
  },
  {
    actionType: 'shareEmail',
    tooltipMessages: {
      idle: 'actions.shareEmail.tooltip.idle',
      pending: 'actions.shareEmail.tooltip.pending',
      succeeded: 'actions.shareEmail.tooltip.succeeded',
      failed: 'actions.shareEmail.tooltip.failed',
    },
    buttonTexts: {
      idle: 'actions.shareEmail.button.idle',
      pending: 'actions.shareEmail.button.pending',
      succeeded: 'actions.shareEmail.button.succeeded',
      failed: 'actions.shareEmail.button.failed',
    },
    IconComponent: Mail,
  },
];

export const LIBRARY_VIEW_ACTIONS = VIDEO_ACTIONS.filter(({ actionType }) => {
  return ([
    'rename',
    'share',
    'download',
    'move',
    'delete',
  ] as ActionType[]).includes(actionType);
});
